import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import POSPage from "./POSPage";

export default function POSStandalonePage() {
  const { user, loading, hasModule } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#161616]">
        <div className="w-10 h-10 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!hasModule("pos")) return <Navigate to="/dashboard" replace />;

  return (
    <div data-testid="pos-standalone-page">
      <POSPage />
    </div>
  );
}
